import { useDecorateWithResultAndAPISetState } from './use-decorate-with-result-and-api-set-state';
import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';
import { useMemo, useRef } from 'react';
import { useDecorateWithTimings } from './use-decorate-post-query-with-timings';
import { COMPONENT } from '../../common/ufo-experiences';

/**
 * This decorator adds capabilities of API state tracking and debouncing to the plain PostQuerySupplier.
 * Think of this as an internal private method of useProductStateMachine.
 * @returns A post query supplier which also aware of setting its respective API state.
 */
export var usePostQueryDecorator = function usePostQueryDecorator(_ref) {
  var setAPIState = _ref.setAPIState,
    setState = _ref.setState,
    postQueryItemSupplier = _ref.postQueryItemSupplier,
    id = _ref.id;
  var ufoPostQueryLoadExperience = useRef(new UFOExperience("".concat(id, "-post-query-results-load"), {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.InlineResult,
    platform: {
      component: COMPONENT
    }
  }));
  var decorateWithTimings = useDecorateWithTimings();
  var timedItemSupplier = useMemo(function () {
    return decorateWithTimings(postQueryItemSupplier);
  }, [postQueryItemSupplier, decorateWithTimings]);
  var decoratedPostQuery = useDecorateWithResultAndAPISetState({
    setState: setState,
    setAPIState: setAPIState,
    ufoExperience: ufoPostQueryLoadExperience.current,
    searchItemSupplier: timedItemSupplier
  });
  return decoratedPostQuery;
};